import React from "react";

export default function AdminNotices() {
  return (
    <div className="min-h-[40vh]">
      <h1 className="text-2xl font-bold">공지사항 관리</h1>
      <p className="text-gray-500 mt-2">이 페이지는 준비 중입니다.</p>
    </div>
  );
}
